import { I13VENTCHAUFGAZ_State } from '@batical/types/src'

const I13VENTCHAUFGAZ: I13VENTCHAUFGAZ_State = {
  bati_version: 1,
  deleted: 0,
  name: '',
  saveDate: 0,
  ventilation_uuid: '0',
  format_uuid: '0',
  in_puissanceTotal: 1000.0,
  in_dnConduitChemineTirage: 300.0,
  in_surfaceChaufferie: 25.0,
  res_vhParoi: 0.0,
  res_vh_gaine_ventilation: 0.0,
  res_VB_paroi: 0.0,
  res_VB_conduite_mini: 0.0,
  res_VB_paroi_comburant: 0.0,
  res_debit_VB: 0.0,
  res_longeurVH: 0.0,
  res_longeurVB: 0.0,
  res_vb_comburant: 0.0,
  in_longeurVH: 158.0,
  res_hauteurVH: 0.0,
  in_longeurVB: 158.0,
  res_largeurVB: 0.0,
  res_diametreCirculaireVH: 0.0,
  res_diametreCirculaireVB: 0.0,
  mode: 'none',
  calcul_code: 'I13VENTCHAUFGAZ'
}

export default I13VENTCHAUFGAZ
